import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfig } from '../Config/api.config';
@Injectable({
  providedIn: 'root'
})
export class TopUpService {

  constructor(private http: HttpClient) {}

   getTopUpData(userSession: string): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

    return this.http.get(
      `${ApiConfig.baseUrl}/topUp/get-top-up-data`,
      { headers }
    );
  }
  postTopUp(userSession: string, topUpMethodId: string, voucherPin: string, amount: number, serviceFee: number, totalAmount: number): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

    const request = {
      topUpMethodId,
      voucherPin,
      amount,
      serviceFee,
      totalAmount
    };
    return this.http.post(
      `${ApiConfig.baseUrl}/topUp/top-up`,
      request,
      {
        headers
      }
    );
  }
  postTopMeUp(userSession: string, amount: number,  payerId: string, newPayerName: string, newPayerNumber: string, newPayerDisplayNumber: string): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

    const request = {
      payerId,
      amount,
      newPayerName,
      newPayerNumber,
      newPayerDisplayNumber
    };
    return this.http.post(
      `${ApiConfig.baseUrl}/topUp/top-me-up`,
      request,
      {
        headers
      }
    );
  }
}